export default __webpack_public_path__ + "static/media/ins_logo.a13f3a64.png";